(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complementos-macuca"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '[data-section-type="complementos-macuca"]';

    const initCarousel = (section) => {
      if (!section) return;

      const rail = section.querySelector('[data-macuca-rail]');
      const cards = Array.from(section.querySelectorAll('.macuca-card'));
      const dots = Array.from(section.querySelectorAll('[data-macuca-dot]'));

      if (!rail || rail.dataset.macucaCarouselReady === 'true') return;
      if (cards.length < 2 || cards.length !== dots.length) return;

      rail.dataset.macucaCarouselReady = 'true';
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let updateFrame = null;
      let pointerId = null;
      let pointerStartX = 0;
      let pointerStartScroll = 0;
      let suppressClick = false;

      const getClosestCardIndex = () => {
        const railRect = rail.getBoundingClientRect();
        const railCenter = railRect.left + (railRect.width / 2);
        let activeIndex = 0;
        let activeDistance = Number.POSITIVE_INFINITY;

        cards.forEach((card, index) => {
          const cardRect = card.getBoundingClientRect();
          const cardCenter = cardRect.left + (cardRect.width / 2);
          const distance = Math.abs(cardCenter - railCenter);
          if (distance < activeDistance) {
            activeDistance = distance;
            activeIndex = index;
          }
        });

        return activeIndex;
      };

      const scrollToCard = (index) => {
        const railRect = rail.getBoundingClientRect();
        const cardRect = cards[index].getBoundingClientRect();
        rail.scrollTo({
          left: rail.scrollLeft + cardRect.left + (cardRect.width / 2) - railRect.left - (railRect.width / 2),
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      };

      const updateActiveDot = () => {
        updateFrame = null;
        const activeIndex = getClosestCardIndex();

        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const requestUpdate = () => {
        if (updateFrame === null) {
          updateFrame = window.requestAnimationFrame(updateActiveDot);
        }
      };

      rail.addEventListener('scroll', requestUpdate, { passive: true });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => scrollToCard(index));
      });

      rail.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (event.target.closest('.macuca-card__cta')) {
          suppressClick = false;
          return;
        }
        pointerId = event.pointerId;
        pointerStartX = event.clientX;
        pointerStartScroll = rail.scrollLeft;
        suppressClick = false;
      });

      rail.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId) return;
        const distance = event.clientX - pointerStartX;
        if (Math.abs(distance) > 5 && !suppressClick) {
          suppressClick = true;
          rail.setPointerCapture(pointerId);
          rail.classList.add('is-dragging');
        }
        if (suppressClick) rail.scrollLeft = pointerStartScroll - distance;
      });

      const stopDragging = (event) => {
        if (event.pointerId !== pointerId) return;
        rail.classList.remove('is-dragging');
        if (rail.hasPointerCapture(pointerId)) rail.releasePointerCapture(pointerId);
        pointerId = null;
        if (suppressClick) {
          scrollToCard(getClosestCardIndex());
        } else {
          requestUpdate();
        }
      };

      rail.addEventListener('pointerup', stopDragging);
      rail.addEventListener('pointercancel', stopDragging);
      rail.addEventListener('click', (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }, true);

      updateActiveDot();
    };

    const initAll = (root = document) => {
      if (root.matches?.(sectionSelector)) initCarousel(root);
      root.querySelectorAll(sectionSelector).forEach(initCarousel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-compromiso"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '[data-section-type="video-compromiso"]';

    const initSection = (section) => {
      if (!section) return;

      const container = section.querySelector('.compromiso-container');
      if (!container || container.dataset.compromisoReady === 'true') return;
      container.dataset.compromisoReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const video = section.querySelector('[data-deferred-video]');
      const toggle = section.querySelector('[data-video-toggle]');
      const media = video?.closest('.compromiso-media');
      const story = section.querySelector('.compromiso-story');
      let userPaused = false;

      if (section.dataset.motion === 'true' && !reduceMotion) {
        section.classList.add('is-motion-ready');

        const reveal = () => section.classList.add('is-revealed');
        if ('IntersectionObserver' in window) {
          const revealObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              reveal();
              revealObserver.disconnect();
            });
          }, { rootMargin: '-8% 0px' });
          revealObserver.observe(section);
        } else {
          reveal();
        }
      }

      if (!video) return;

      const syncToggle = () => {
        if (!toggle) return;
        const paused = video.paused;
        toggle.classList.toggle('is-paused', paused);
        toggle.setAttribute('aria-label', paused ? 'Reproducir vídeo' : 'Pausar vídeo');
      };

      const syncVideoLayout = () => {
        if (!story || !video.videoWidth || !video.videoHeight) return;

        const videoRatio = video.videoWidth / video.videoHeight;
        const isLandscape = videoRatio >= 1.2;
        story.style.setProperty('--compromiso-video-ratio', String(videoRatio));
        story.classList.toggle('is-landscape-video', isLandscape);
        story.classList.toggle('is-portrait-video', !isLandscape);

        if (isLandscape) {
          const landscapeMediaShare = 1.62 / (1.62 + 0.78);
          story.style.setProperty('--compromiso-story-ratio', String(videoRatio / landscapeMediaShare));
        } else {
          story.style.removeProperty('--compromiso-story-ratio');
        }
      };

      const loadVideo = (shouldPlay = false) => {
        if (video.dataset.videoLoaded !== 'true' && video.dataset.src) {
          const source = document.createElement('source');
          source.src = video.dataset.src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.dataset.videoLoaded = 'true';
          video.load();
        }

        if (shouldPlay) {
          video.play().catch(() => {});
        }

        syncToggle();
      };

      if (toggle) {
        toggle.hidden = false;
        toggle.addEventListener('click', () => {
          if (video.dataset.videoLoaded !== 'true') {
            userPaused = false;
            loadVideo(true);
          } else if (video.paused) {
            userPaused = false;
            video.play().catch(() => {});
          } else {
            userPaused = true;
            video.pause();
          }
        });
      }

      video.addEventListener('playing', () => {
        media?.classList.add('is-video-active');
        syncToggle();
      });
      video.addEventListener('pause', syncToggle);
      video.addEventListener('error', () => media?.classList.remove('is-video-active'));
      video.addEventListener('loadedmetadata', syncVideoLayout);
      if (video.readyState >= 1) syncVideoLayout();
      syncToggle();

      if (!('IntersectionObserver' in window)) {
        loadVideo(!reduceMotion);
        return;
      }

      const loadObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          loadVideo(false);
          loadObserver.disconnect();
        });
      }, { rootMargin: '240px 0px' });

      const playbackObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const shouldAutoplay = video.dataset.autoplay === 'true' && !reduceMotion && !userPaused;
            loadVideo(shouldAutoplay);
          } else if (video.dataset.videoLoaded === 'true' && !video.paused) {
            video.pause();
          }
        });
      }, { threshold: 0.25 });

      loadObserver.observe(video);
      playbackObserver.observe(video);
    };

    const initAll = (root = document) => {
      if (root.matches?.(sectionSelector)) initSection(root);
      root.querySelectorAll(sectionSelector).forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
